import { Flex } from "@chakra-ui/layout";
import { Link } from "@chakra-ui/react";
import history from "infra/helpers/history";
import useFinishOnboarding from "core/features/onboarding/hooks/useFinishOnboarding";
import { useCurrentTenant } from "core/features/auth/tenant.store";

function ButtonPular() {
  const { tenant } = useCurrentTenant();
  const { mutate: handleSave } = useFinishOnboarding(tenant.id);

  const onPular = () => {
    handleSave(undefined, {
      onSuccess: (data: any) => {
        console.log("Salvo", data);
      },
      onError: (err: any) => {
        console.log("Erro", err);
      },
    });
    history.push("/dashboard");
  };

  return (
    <Flex align="flex-end" flexDir="column">
      <Link fontSize="14px" lineHeight="21px" color="#939393" onClick={onPular}>
        PULAR
      </Link>
    </Flex>
  );
}

export default ButtonPular;
